// Class: starling.utils.Node

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var Node = function(i,x,y) {
	this.i = i;
	this.x = x;
	this.y = y;
	this.prev = null;
	this.next = null;
	this.z = 0;
	this.prevZ = null;
	this.nextZ = null;
	this.steiner = false;
}

// Meta

Node.__name__ = "starling.utils.Node";
Node.__isInterface__ = false;
Node.prototype = {
	
};
Node.prototype.__class__ = Node.prototype.constructor = $hxClasses["starling.utils.Node"] = Node;

// Init



// Statics




// Export

exports.default = Node;